module.exports = __webpack_public_path__ + "img/icon_moreuser_index.0f31feca.svg";